var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nut-picker',{attrs:{"is-visible":_vm.isVisible,"title":_vm.title,"list-data":_vm.listData,"default-value-data":_vm.defaultValueData,"custom-class-name":`nut-datepicker`},on:{"close":function($event){return _vm.switchPicker('isVisible')},"confirm":_vm.setChooseValue,"choose":_vm.updateChooseValue,"close-update":_vm.closeUpdateChooseValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }